import { useLoading } from '../contexts/LoadingContext';

export const useCustomLoading = () => {
  const { setLoading } = useLoading();

  const showLoading = (message = 'Loading...') => {
    setLoading(true, message);
  };

  const hideLoading = () => {
    setLoading(false);
  };

  const withLoading = async (asyncFunction, message = 'Loading...') => {
    try {
      setLoading(true, message);
      const result = await asyncFunction();
      return result;
    } finally {
      setLoading(false);
    }
  };

  return { showLoading, hideLoading, withLoading };
};
